import { defineMessages } from 'react-intl';

export default defineMessages({
    greeting: {
        id: '_.outstanding_view.greeting',
        defaultMessage: 'Hello, {name}'
    },
    yourlookingat: {
        id: '_.outstanding_view.yourlookingat',
        defaultMessage: `You're looking at your`
    },
    youllPay: {
        id: '_.outstanding_view.youllPay',
        defaultMessage:
            ". You're paying {approvalInterestRate} interest per month."
    }
});
